import { Component, input, ViewEncapsulation } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { TooltipDirective } from '../../../tooltip/tooltip.directive';

@Component({
    selector: 'app-menu-item-cabinet',
    templateUrl: './menu-item.component.html',
    styleUrl: './menu-item.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [RouterLinkActive, TooltipDirective],
    host: {
        '[class.collapsed]': 'isCollapsed()'
    }
})
export class MenuItemCabinetComponent {
    isCollapsed = input(false);
    tooltipText = input('');
    badge = input<number | undefined>(undefined);
}
